import React from 'react';
import PropTypes from 'prop-types';

export default function CardOffset({ children, value }) {
  return <div style={{ paddingBottom: value }}>{children}</div>;
}

CardOffset.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-card/CardOffset/index.js